<script setup lang="ts">
interface SelectOption {
  title: string
  value: string | number
}

interface Props {
  modelValue: string | number | null
  label?: string
  options: SelectOption[]
  disabled?: boolean
  error?: string
}

interface Emits {
  (e: 'update:modelValue', value: string | number | null): void
}

withDefaults(defineProps<Props>(), {
  label: '',
  disabled: false,
  error: '',
})

defineEmits<Emits>()
</script>

<template>
  <v-select
    :model-value="modelValue"
    :label="label"
    :items="options"
    :disabled="disabled"
    :error-messages="error ? [error] : []"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<style scoped lang="scss">
</style>
